import { format } from "date-fns";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { Calendar } from "../../calendar";
import { setLegalRepresentativeCreateRequestField, setLegalRepresentativeUpdateRequestField } from "../../../../pages/clienti/feature/legalRepresentative/slice";

interface Props {
    mode: "create" | "edit"
}

export function RappLegaleDataIngUsc({ mode }: Props) {
    const legatRepresentativeState = useAppSelector(state => state.legalRapresentative)
    const dispatch = useAppDispatch()

    const legalRepresentativeRequest = mode === "create" ? legatRepresentativeState.legalRepresentativeCreateRequest : legatRepresentativeState.legalRepresentativeUpdateRequest

    return (
        <div className="grid grid-cols-2 gap-4">
            <Calendar
                required
                errorLabel={legatRepresentativeState.legalRepresentativeCreateErrors.activationDate}
                label="Data Ingresso"
                selected={legalRepresentativeRequest.activationDate}
                onChange={(date) => {
                    if (!date) return
                    if (mode === "create")
                        dispatch(setLegalRepresentativeCreateRequestField({ field: "activationDate", value: format(new Date(date), 'yyyy-MM-dd') }))
                    else
                        dispatch(setLegalRepresentativeUpdateRequestField({ field: "activationDate", value: format(new Date(date), 'yyyy-MM-dd') }))
                }}
            />
            <Calendar
                label="Data Uscita"
                selected={legalRepresentativeRequest.deactivationDate}
                onChange={(date) => {
                    if (!date) return
                    if (mode === "create")
                        dispatch(setLegalRepresentativeCreateRequestField({ field: "deactivationDate", value: format(new Date(date), 'yyyy-MM-dd') }))
                    else
                        dispatch(setLegalRepresentativeUpdateRequestField({ field: "deactivationDate", value: format(new Date(date), 'yyyy-MM-dd') }))
                }}
            />
        </div>
    )
}